const Mutations = Object.freeze({
	SET_ACTIVITIES: 'activityBuilder/SET_ACTIVITIES',
	SET_LOADING: 'activityBuilder/SET_LOADING',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/CLEAR',
	LOAD_ACTIVITIES: 'activityBuilder/LOAD_ACTIVITIES',
	CLONE: 'activityBuilder/CLONE',
	DELETE_ACTIVITY: 'activityBuilder/DELETE_ACTIVITY',
});

export const Getters = Object.freeze({
	ACTIVITIES: 'activityBuilder/ACTIVITIES',
	LOADING: 'activityBuilder/LOADING',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
import activityDetails from './activityDetails';
import activityComputedFields from './activityComputedFields';
import activityStaticFields from './activityStaticFields';
import activityItem from './activityItem';
import activityFilters from './activityFilters';
export default {
	state: {
		activities: [],
		loading: false,
	},
	mutations: {
		[Mutations.SET_ACTIVITIES](state, items) {
			state.activities = items;
		},
		[Mutations.SET_LOADING](state, items) {
			state.loading = items;
		},
	},
	modules: {
		activityDetails,
		activityComputedFields,
		activityStaticFields,
		activityItem,
		activityFilters,
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_ACTIVITIES, []);
				resolve(true);
			});
		},
		[Actions.LOAD_ACTIVITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getActivities()
					.then((resp) => {
						commit(Mutations.SET_ACTIVITIES, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_ACTIVITY]({ commit, dispatch, state }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteActivity(id)
					.then(() => {
						let activities = state.activities;
						let activity = activities.find((x) => x.Id == id);
						if (activity) {
							let index = activities.indexOf(activity);
							activities.splice(index, 1);
						}
						commit(Mutations.SET_ACTIVITIES, activities);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.CLONE]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.cloneActivity(item)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(Actions.LOAD_ACTIVITIES);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.ACTIVITIES]: (state) => {
			return JSON.parse(JSON.stringify(state.activities));
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
	},
};
